/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateArticleHarmfulFactorSuppExamDictDto } from './CreateUpdateArticleHarmfulFactorSuppExamDictDto';
import {
    CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSON,
    CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSONTyped,
    CreateUpdateArticleHarmfulFactorSuppExamDictDtoToJSON,
} from './CreateUpdateArticleHarmfulFactorSuppExamDictDto';

/**
 * 
 * @export
 * @interface CreateUpdateArticleDto
 */
export interface CreateUpdateArticleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    legalBasis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    legalBasisType?: CreateUpdateArticleDtoLegalBasisTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateArticleDto
     */
    legalBasisTypeValidFrom?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateArticleDto
     */
    lp?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateArticleDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    pdfTemplateType?: CreateUpdateArticleDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    engPdfTemplateType?: CreateUpdateArticleDtoEngPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    mode?: CreateUpdateArticleDtoModeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    registerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    cardType?: CreateUpdateArticleDtoCardTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    attention?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateArticleDto
     */
    automaticReady: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateArticleDto
     */
    pricingGroupId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateArticleDto
     */
    autoSupporting: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateArticleDto
     */
    supportingExaminationsOptional: boolean;
    /**
     * 
     * @type {Array<CreateUpdateArticleHarmfulFactorSuppExamDictDto>}
     * @memberof CreateUpdateArticleDto
     */
    articleHarmfulFactorSuppExamDicts?: Array<CreateUpdateArticleHarmfulFactorSuppExamDictDto> | null;
}


/**
 * @export
 */
export const CreateUpdateArticleDtoLegalBasisTypeEnum = {
    Art43Art229: 'Art43Art229'
} as const;
export type CreateUpdateArticleDtoLegalBasisTypeEnum = typeof CreateUpdateArticleDtoLegalBasisTypeEnum[keyof typeof CreateUpdateArticleDtoLegalBasisTypeEnum];

/**
 * @export
 */
export const CreateUpdateArticleDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type CreateUpdateArticleDtoPdfTemplateTypeEnum = typeof CreateUpdateArticleDtoPdfTemplateTypeEnum[keyof typeof CreateUpdateArticleDtoPdfTemplateTypeEnum];

/**
 * @export
 */
export const CreateUpdateArticleDtoEngPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type CreateUpdateArticleDtoEngPdfTemplateTypeEnum = typeof CreateUpdateArticleDtoEngPdfTemplateTypeEnum[keyof typeof CreateUpdateArticleDtoEngPdfTemplateTypeEnum];

/**
 * @export
 */
export const CreateUpdateArticleDtoModeEnum = {
    Doctor: 'Doctor',
    Psychologist: 'Psychologist',
    Ophthalmologist: 'Ophthalmologist',
    Neurologist: 'Neurologist',
    Psychiatrist: 'Psychiatrist',
    Laryngologist: 'Laryngologist'
} as const;
export type CreateUpdateArticleDtoModeEnum = typeof CreateUpdateArticleDtoModeEnum[keyof typeof CreateUpdateArticleDtoModeEnum];

/**
 * @export
 */
export const CreateUpdateArticleDtoCardTypeEnum = {
    Preventive: 'Preventive',
    Psychologist: 'Psychologist',
    PsychologistWeapon: 'PsychologistWeapon',
    Weapon: 'Weapon',
    Driver: 'Driver',
    Sanitary: 'Sanitary',
    Sport: 'Sport'
} as const;
export type CreateUpdateArticleDtoCardTypeEnum = typeof CreateUpdateArticleDtoCardTypeEnum[keyof typeof CreateUpdateArticleDtoCardTypeEnum];


/**
 * Check if a given object implements the CreateUpdateArticleDto interface.
 */
export function instanceOfCreateUpdateArticleDto(value: object): value is CreateUpdateArticleDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('automaticReady' in value) || value['automaticReady'] === undefined) return false;
    if (!('autoSupporting' in value) || value['autoSupporting'] === undefined) return false;
    if (!('supportingExaminationsOptional' in value) || value['supportingExaminationsOptional'] === undefined) return false;
    return true;
}

export function CreateUpdateArticleDtoFromJSON(json: any): CreateUpdateArticleDto {
    return CreateUpdateArticleDtoFromJSONTyped(json, false);
}

export function CreateUpdateArticleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateArticleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'legalBasis': json['legalBasis'] == null ? undefined : json['legalBasis'],
        'legalBasisType': json['legalBasisType'] == null ? undefined : json['legalBasisType'],
        'legalBasisTypeValidFrom': json['legalBasisTypeValidFrom'] == null ? undefined : (new Date(json['legalBasisTypeValidFrom'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'code': json['code'] == null ? undefined : json['code'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'active': json['active'],
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'engPdfTemplateType': json['engPdfTemplateType'] == null ? undefined : json['engPdfTemplateType'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'attention': json['attention'] == null ? undefined : json['attention'],
        'automaticReady': json['automaticReady'],
        'pricingGroupId': json['pricingGroupId'] == null ? undefined : json['pricingGroupId'],
        'autoSupporting': json['autoSupporting'],
        'supportingExaminationsOptional': json['supportingExaminationsOptional'],
        'articleHarmfulFactorSuppExamDicts': json['articleHarmfulFactorSuppExamDicts'] == null ? undefined : ((json['articleHarmfulFactorSuppExamDicts'] as Array<any>).map(CreateUpdateArticleHarmfulFactorSuppExamDictDtoFromJSON)),
    };
}

export function CreateUpdateArticleDtoToJSON(value?: CreateUpdateArticleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'legalBasis': value['legalBasis'],
        'legalBasisType': value['legalBasisType'],
        'legalBasisTypeValidFrom': value['legalBasisTypeValidFrom'] == null ? undefined : ((value['legalBasisTypeValidFrom'] as any).toISOString()),
        'reason': value['reason'],
        'code': value['code'],
        'lp': value['lp'],
        'active': value['active'],
        'pdfTemplateType': value['pdfTemplateType'],
        'engPdfTemplateType': value['engPdfTemplateType'],
        'mode': value['mode'],
        'registerId': value['registerId'],
        'cardType': value['cardType'],
        'attention': value['attention'],
        'automaticReady': value['automaticReady'],
        'pricingGroupId': value['pricingGroupId'],
        'autoSupporting': value['autoSupporting'],
        'supportingExaminationsOptional': value['supportingExaminationsOptional'],
        'articleHarmfulFactorSuppExamDicts': value['articleHarmfulFactorSuppExamDicts'] == null ? undefined : ((value['articleHarmfulFactorSuppExamDicts'] as Array<any>).map(CreateUpdateArticleHarmfulFactorSuppExamDictDtoToJSON)),
    };
}

